module.exports = __webpack_public_path__ + "img/cashier-icon-01.864aa75b.png";